'use strict';
import Megatron from '@stencil/megatron';
import prepareSnapshotUrl from '@stencil/hotels-utils/src/get-reviews-snapshot-url';

export async function getReviewsSnapshotData(hotelId, idf, val) {
  const url = prepareSnapshotUrl(hotelId, idf, val);
  const response = await Megatron({
    name: 'Fetch Snapshot data',
    type: 'GET',
    url,
  });
  return response;
}

export default getReviewsSnapshotData;
